import React from 'react';

export default props => <>
    {props.errors.filter(e => e.campo === props.campo).map(e =>
        <span key={e.errore} className="error invalid-feedback">{e.errore}<br /></span>)}
</>;
